import React from 'react';
import PropTypes from '@app/utils/propTypes';

import classNames from 'classnames';

import { Card, CardBody, CardTitle, CardSubtitle } from 'reactstrap';

const IconWidget = ({
  bgColor,
  icon: Icon,
  iconProps,
  title,
  subtitle,
  ip,
  className,
  ...restProps
}) => {
  const classes = classNames('cr-widget', className, {
    [`bg-${bgColor}`]: bgColor,
  });
  return (
    <Card inverse className={classes} {...restProps}>
      <CardBody className="cr-widget__icon">
        <Icon {...iconProps} />
      </CardBody>
      <CardBody>
        <CardTitle style={{fontSize: '12px'}}>{title}</CardTitle>
        <CardSubtitle style={{fontSize: '11px'}}>{subtitle}</CardSubtitle>
        <CardSubtitle style={{fontSize: '11px'}}>{ip}</CardSubtitle>
      </CardBody>
    </Card>
  );
};

IconWidget.propTypes = {
  bgColor: PropTypes.string,
  icon: PropTypes.component,
  iconProps: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

IconWidget.defaultProps = {
  bgColor: 'primary',
  icon: 'span',
  iconProps: { size: 25 },
};

export default IconWidget;
